import { render, staticRenderFns } from "./Selectable.vue?vue&type=template&id=673b1ff6&scoped=true&"
import script from "./Selectable.vue?vue&type=script&lang=js&"
export * from "./Selectable.vue?vue&type=script&lang=js&"
import style0 from "./Selectable.scss?vue&type=style&index=0&id=673b1ff6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b1ff6",
  null
  
)

export default component.exports